import GroupsIcon from "@mui/icons-material/Groups";
import permissions from "app/permissions";
import { DoctoralServicePath } from "utils/constants";
import { tenants } from "utils/tenants";
import ListDoctorants from "./List";
import CreateDoctorant from "./Create";
import ShowDoctorant from "./Show/Show";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <GroupsIcon />,
  name: `${DoctoralServicePath}doctorants`,
  title: "Докторанти",
  list: <ListDoctorants />,
  create: <CreateDoctorant />,
  createPermission: permissions.canAddDoctorant,
  show: <ShowDoctorant />,
  permission: permissions.canPreviewDoctorants,
};
